import AirDatepicker from "air-datepicker";
import localeJa from "air-datepicker/locale/ja";
import dayjs from "dayjs";
import isLeapYear from "dayjs/plugin/isLeapYear"; // import plugin
import ja from "dayjs/locale/ja";
import minMax from "dayjs/plugin/minMax";
dayjs.extend(isLeapYear); // use plugin
dayjs.extend(minMax); // use plugin
dayjs.locale(ja); // use locale
dayjs().format();

export const insertDatePicker = () => {
  // ====================================================
  // カレンダーを生成・挿入
  const placeholder = document.createElement("div");
  const beforeNode = document.createElement("div");
  const datePickerPlaceholder = document.createElement("div");

  placeholder.appendChild(beforeNode);

  // ====================================================
  // 共通配送オプション商品の値を取得
  const commonShippingOptionMetafieldsNoDeliveryElements =
    document.querySelectorAll(
      '[data-mfkey="commonShippingOptionMetafields__no_delivery"]'
    ); // 配送不可日(任意)
  const commonShippingOptionMetafieldsNoDeliveryDayOfWeekElements =
    document.querySelectorAll(
      '[data-mfkey="commonShippingOptionMetafields__no_delivery_day_of_week"]'
    ); // 配送不可曜日(任意)
  const commonShippingOptionMetafieldsMinDeliveryLeadTimeElement =
    document.querySelector(
      '[data-mfkey="commonShippingOptionMetafields__min_delivery_lead_time"]'
    ) as HTMLElement; // 最短お届けにかかる日数(任意)

  let commonShippingOptionMetafieldsNoDeliveryDays = [];
  commonShippingOptionMetafieldsNoDeliveryElements.forEach(
    (el: HTMLElement) => {
      if (el.dataset.mfvalue && el.dataset.mfvalue !== "") {
        commonShippingOptionMetafieldsNoDeliveryDays.push(
          dayjs(el.dataset.mfvalue).format("YYYY-MM-DD")
        );
      }
    }
  );
  console.log(
    "commonShippingOptionMetafieldsNoDeliveryDays",
    commonShippingOptionMetafieldsNoDeliveryDays
  );

  let commonShippingOptionMetafieldsNoDeliveryDayOfWeeks = [];
  commonShippingOptionMetafieldsNoDeliveryDayOfWeekElements.forEach(
    (el: HTMLElement) => {
      switch (el.dataset.mfvalue) {
        case "日":
          commonShippingOptionMetafieldsNoDeliveryDayOfWeeks.push(0);
          break;
        case "月":
          commonShippingOptionMetafieldsNoDeliveryDayOfWeeks.push(1);
          break;
        case "火":
          commonShippingOptionMetafieldsNoDeliveryDayOfWeeks.push(2);
          break;
        case "水":
          commonShippingOptionMetafieldsNoDeliveryDayOfWeeks.push(3);
          break;
        case "木":
          commonShippingOptionMetafieldsNoDeliveryDayOfWeeks.push(4);
          break;
        case "金":
          commonShippingOptionMetafieldsNoDeliveryDayOfWeeks.push(5);
          break;
        case "土":
          commonShippingOptionMetafieldsNoDeliveryDayOfWeeks.push(6);
          break;
        default:
          console.log("配送不可曜日（任意）の値が不正です。");
      }
    }
  );

  console.log(
    "commonShippingOptionMetafieldsMinDeliveryLeadTimeElement.dataset.mfvalue",
    commonShippingOptionMetafieldsMinDeliveryLeadTimeElement.dataset.mfvalue
  );
  const commonShippingOptionMetafieldsMinDeliveryLeadTime = Number(
    commonShippingOptionMetafieldsMinDeliveryLeadTimeElement.dataset.mfvalue
  );

  // ====================================================
  // ====================================================
  const shippingDateStartElements = document.querySelectorAll(
    '[data-mfkey="shipping-date-start"]'
  ); // 配送可能期間開始日(必須)
  const shippingDateEndElements = document.querySelectorAll(
    '[data-mfkey="shipping-date-end"]'
  ); // 配送可能期間終了日(必須)
  const noDeliveryElements = document.querySelectorAll(
    '[data-mfkey="no_delivery"]'
  ); // 配送不可日(任意)
  const noDeliveryDayOfWeekElements = document.querySelectorAll(
    '[data-mfkey="no_delivery_day_of_week"]'
  ); // 配送不可曜日(任意)
  const minDeliveryLeadTimeElements = document.querySelectorAll(
    '[data-mfkey="min_delivery_lead_time"]'
  ); // 最短お届けにかかる日数(任意)

  // ================================================================
  // 配送可能期間開始日（必須）をminDateに設定
  let minDays = [];
  console.log("shippingDateStartElements", shippingDateStartElements);
  shippingDateStartElements.forEach((el: HTMLElement) => {
    if (el.dataset.mfvalue !== "" && el.dataset.mfvalue !== null) {
      minDays.push(dayjs(el.dataset.mfvalue));
    }
  });
  // 重複を排除する処理を追加
  let uniqueMinDays = [...new Set(minDays)];
  console.log("uniqueMinDays", uniqueMinDays);
  const maxMinDay = dayjs.max(uniqueMinDays);
  console.log("maxMinDay", maxMinDay);

  // ================================================================
  // 配送可能期間終了日（必須）をmaxDateに設定
  let maxDays = [];
  console.log("shippingDateEndElements", shippingDateEndElements);
  shippingDateEndElements.forEach((el: HTMLElement) => {
    if (el.dataset.mfvalue !== "" && el.dataset.mfvalue !== null) {
      maxDays.push(dayjs(el.dataset.mfvalue));
    }
  });
  // 重複を排除する処理を追加
  let uniqueMaxDays = [...new Set(maxDays)];
  console.log("uniqueMaxDays", uniqueMaxDays);
  const minMaxDay = dayjs.min(uniqueMaxDays);
  console.log("minMaxDay", minMaxDay);

  // ================================================================
  // 配送不可日（任意）を配列に格納
  let noDeliveryDays = [];
  noDeliveryElements.forEach((el: HTMLElement) => {
    if (el.dataset.mfvalue !== "" && el.dataset.mfvalue !== null) {
      noDeliveryDays.push(dayjs(el.dataset.mfvalue).format("YYYY-MM-DD"));
    }
  });
  // 重複を排除する処理を追加
  let uniqueNoDeliveryDays = [
    ...new Set(commonShippingOptionMetafieldsNoDeliveryDays),
    ...new Set(noDeliveryDays),
  ];
  console.log("noDeliveryDays", noDeliveryDays);
  console.log("uniqueNoDeliveryDays", uniqueNoDeliveryDays);

  // ================================================================
  // 配送不可曜日（任意）を配列に格納
  let noDeliveryDayOfWeeks = [];
  noDeliveryDayOfWeekElements.forEach((el: HTMLElement) => {
    switch (el.dataset.mfvalue) {
      case "日":
        noDeliveryDayOfWeeks.push(0);
        break;
      case "月":
        noDeliveryDayOfWeeks.push(1);
        break;
      case "火":
        noDeliveryDayOfWeeks.push(2);
        break;
      case "水":
        noDeliveryDayOfWeeks.push(3);
        break;
      case "木":
        noDeliveryDayOfWeeks.push(4);
        break;
      case "金":
        noDeliveryDayOfWeeks.push(5);
        break;
      case "土":
        noDeliveryDayOfWeeks.push(6);
        break;
      default:
        console.log("配送不可曜日（任意）の値が不正です。");
    }
  });
  // 重複を排除する処理を追加
  let uniqueNoDeliveryDayOfWeeks = [
    ...new Set(commonShippingOptionMetafieldsNoDeliveryDayOfWeeks),
    ...new Set(noDeliveryDayOfWeeks),
  ];
  console.log("uniqueNoDeliveryDayOfWeeks", uniqueNoDeliveryDayOfWeeks);

  // ================================================================
  // 最短お届けにかかる日数（任意）を取得
  let minDeliveryLeadTimes = [];
  minDeliveryLeadTimeElements.forEach((el: HTMLElement) => {
    if (el.dataset.mfvalue !== "" && el.dataset.mfvalue !== null) {
      minDeliveryLeadTimes.push(Number(el.dataset.mfvalue));
    } else {
      minDeliveryLeadTimes.push(
        commonShippingOptionMetafieldsMinDeliveryLeadTime
      );
    }
  });
  // 重複を排除する処理を追加
  let uniqueMinDeliveryLeadTimes: number[] = [...new Set(minDeliveryLeadTimes)];
  console.log("uniqueMinDeliveryLeadTimes", uniqueMinDeliveryLeadTimes);
  const tempMaxMinDeliveryLeadTime = Math.max(...uniqueMinDeliveryLeadTimes);

  const maxMinDeliveryLeadTime =
    uniqueMinDeliveryLeadTimes && uniqueMinDeliveryLeadTimes.length > 0
      ? tempMaxMinDeliveryLeadTime
      : commonShippingOptionMetafieldsMinDeliveryLeadTime;
  console.log(
    "commonShippingOptionMetafieldsMinDeliveryLeadTime",
    commonShippingOptionMetafieldsMinDeliveryLeadTime
  );
  console.log("tempMaxMinDeliveryLeadTime", tempMaxMinDeliveryLeadTime);
  console.log("maxMinDeliveryLeadTime", maxMinDeliveryLeadTime);

  // 最短お届け日を現在の日付から計算し取得
  const minDeliveryDateAfterLeadTime = dayjs().add(
    maxMinDeliveryLeadTime,
    "day"
  );
  console.log(
    "minDeliveryDateAfterLeadTime",
    dayjs(minDeliveryDateAfterLeadTime).format("YYYY-MM-DD")
  );

  // ================================================================
  // AirDatepickerのminDateに設定する値を格納する変数
  let setMinDate: dayjs.Dayjs;

  // 最短お届けにかかる日数（任意）と配送可能期間開始日（必須）を比較し、配送可能期間開始日（必須）が最短お届けにかかる日数（任意）よりも後であれば、配送可能期間開始日（必須）をminDateに設定。そうでなければ、最短お届けにかかる日数（任意）をminDateに設定
  console.log("maxMinDay", maxMinDay);
  if (maxMinDay && maxMinDay.isAfter(minDeliveryDateAfterLeadTime)) {
    console.log("maxMinDay.isAfter(minDeliveryDateAfterLeadTime)");
    setMinDate = maxMinDay;
    console.log("setMinDate", setMinDate);
    console.log(
      "setMinDate.format('YYYY-MM-DD')",
      setMinDate.format("YYYY-MM-DD")
    );
  } else {
    console.log("maxMinDay.is NOT After(minDeliveryDateAfterLeadTime)");
    setMinDate = minDeliveryDateAfterLeadTime;
  }

  new AirDatepicker(datePickerPlaceholder, {
    locale: localeJa,
    buttons: ["clear"],
    minDate: setMinDate ? setMinDate.format("YYYY-MM-DD") : false,
    maxDate: minMaxDay ? minMaxDay.format("YYYY-MM-DD") : false,
    onRenderCell({ date, cellType }) {
      // Disable all 12th dates in month
      if (cellType === "day") {
        // 配送不可日にdisabledクラスを追加
        if (uniqueNoDeliveryDays.includes(dayjs(date).format("YYYY-MM-DD"))) {
          return {
            disabled: true,
            classes: "disabled-class",
            attrs: {
              title: "Cell in uniqueNoDeliveryDays is disabled",
            },
          };
        }
        // 配送不可曜日にdisabledクラスを追加
        if (uniqueNoDeliveryDayOfWeeks.includes(date.getDay())) {
          return {
            disabled: true,
            classes: "disabled-class",
            attrs: {
              title: "Cell in uniqueNoDeliveryDayOfWeeks is disabled",
            },
          };
        }
      }
    },
    onSelect({ date, formattedDate }) {
      console.log("onSelect");
      const targetInputElement = document.querySelector(
        "#dateInput"
      ) as HTMLInputElement;
      // チェックアウトボタンを有効化
      console.log("チェックアウトボタンを有効化ロジック");
      console.log("チェックアウトボタンを有効化ロジックdate", date);
      const cartCheckoutBtn = document.querySelector(
        "#cartCheckoutBtn"
      ) as HTMLElement;
      const fakeCartCheckoutBtn = document.querySelector(
        "#fakeCartCheckoutBtn"
      ) as HTMLElement;
      const fakeCartCheckoutBtnText = document.querySelector(
        "#fakeCartCheckoutBtnText"
      ) as HTMLElement;

      const selectedCell = document.querySelector(
        ".air-datepicker-cell.-selected-"
      );
      if (selectedCell) {
        console.log("selectedCell");
        // disabled属性を削除
        cartCheckoutBtn.removeAttribute("disabled");
        cartCheckoutBtn.style.display = "block";
        fakeCartCheckoutBtn.style.display = "none";
        fakeCartCheckoutBtnText.style.display = "none";
      } else {
        console.log("none");
        // disabled属性を追加
        cartCheckoutBtn.setAttribute("disabled", "disabled");
        cartCheckoutBtn.style.display = "none";
        fakeCartCheckoutBtn.style.display = "block";
        fakeCartCheckoutBtnText.style.display = "block";
      }

      console.log("formattedDate", formattedDate);
      targetInputElement.value = formattedDate.toString();
    },
  });
  console.log("datePickerPlaceholder", datePickerPlaceholder);
  placeholder.appendChild(datePickerPlaceholder);
  console.log("placeholder here", placeholder);

  // productForm.insertBefore(placeholder, paymentContainer);
  const targetDateSelectElement = document.querySelector(
    "#cartShippingOption__date"
  ) as HTMLElement;
  console.log("targetDateSelectElement", targetDateSelectElement);
  if (targetDateSelectElement) {
    targetDateSelectElement.appendChild(placeholder);
  }

  // const addToCartBtn = document.querySelector('[data-action="add-to-cart"]');
  // addToCartBtn.addEventListener('click', () => {
  //   const dateIsSelected = document.querySelector('.air-datepicker-cell.-selected-');
  //   console.log('dateIsSelected', dateIsSelected);
  //   if (!dateIsSelected) {
  //     alert('配送希望日を選択してください。');
  //   }
  //   return false;
  // });

  document.querySelectorAll(".air-datepicker-button").forEach((el) => {
    el.addEventListener("click", (e) => {
      console.log("air-datepicker-button clicked");
      e.preventDefault();
    });
  });

  const selectableDays = document.querySelectorAll(
    ".air-datepicker-cell.-day-:not(.-disabled-)"
  );
  // selectableDaysが0件の場合は、cartShippingOption__dateを非表示にする
  if (selectableDays.length === 0 && targetDateSelectElement) {
    targetDateSelectElement.style.display = "none";
    document
      .querySelector("#cartShippingOption__error")
      .classList.remove("hidden");
    document
      .querySelector("#cartShippingOption__dateContainer")
      .classList.add("hidden");
    document
      .querySelector("#cartShippingOption__timeContainer")
      .classList.add("hidden");

    const cartCheckoutBtn = document.querySelector("#cartCheckoutBtn");
    const checkoutBtnError = document.querySelector(
      "#checkoutBtnError"
    ) as HTMLElement;
    cartCheckoutBtn.remove();
    checkoutBtnError.innerText = "お届け可能期間が重なる商品をお選びください";

    document.querySelectorAll(".cartShippingOption__dateNote").forEach((el) => {
      el.classList.add("hidden");
    });
  }
  const cartCheckoutBtn = document.querySelector(
    "#cartCheckoutBtn"
  ) as HTMLElement;
  const fakeCartCheckoutBtn = document.querySelector(
    "#fakeCartCheckoutBtn"
  ) as HTMLElement;
  const fakeCartCheckoutBtnText = document.querySelector(
    "#fakeCartCheckoutBtnText"
  ) as HTMLElement;
  // カート画面に訪れた時、デフォルトでチェックアウトに進まないボタンを表示する
  console.log("チェックアウトに進まないボタン表示");
  cartCheckoutBtn.style.display = "none";
  fakeCartCheckoutBtn.style.display = "block";
  fakeCartCheckoutBtnText.style.display = "none";

  // チェックアウトに進まないボタンを押した時、配送日を選択しないと進めないというテキストを表示する
  fakeCartCheckoutBtn.addEventListener("click", function () {
    fakeCartCheckoutBtnText.style.display = "block";
  });
};
